import React, { useEffect, useState } from 'react';
import './Deposit.scss';
import ImagePath from 'app/utilities/imagePath';
import LocalStorageService from 'app/services/localStorage';
import { accordionData } from 'app/configs/deposit.config';
import { RootState } from 'app/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { USER_TYPE } from 'constants/userType';
import { getCoorporateProfile } from 'app/redux/actions/CorporateProfileAction';
import Accordion from '../../components/Accordion/Accordion';
import METHOD from '../../../constants/method-payment';

const Deposit = function init(): React.ReactElement {
	const isLoggedIn = LocalStorageService.isLoggedIn();
	const [loading, setLoading] = useState(true);
	const coorporateProfile = useSelector((state: RootState) => state.coorporateProfile);
	const user = LocalStorageService.getUserData();
	const dispatch = useDispatch();

	useEffect(() => {
		if (user.userTypeId === USER_TYPE.LENDER_INSTITUTIONAL) {
			dispatch(getCoorporateProfile());
		}
	}, []);

	return (
		<div className="deposit-container">
			<div className="deposit-layout">
				{isLoggedIn && coorporateProfile.dataAccountBalanceIM?.vaNumber && (
					<div className="card information-card">
						<p className="deposit-text">Deposit</p>
						<div className="card virtual-account-info">
							<p className="virtual-account-purpose">
								Tujuan Virtual Account
							</p>
							<p className="virtual-account-holder">{coorporateProfile.dataAccountBalanceIM?.vaName}</p>
							<div className="flex-wrap">
								<img
									referrerPolicy="no-referrer"
									className={loading ? "loading-image" : "bank-logo"}
									src={coorporateProfile.dataAccountBalanceIM?.methodPayment === METHOD.bni ? ImagePath.bankBni.src : ImagePath.bankBsim.src}
									alt={coorporateProfile.dataAccountBalanceIM?.methodPayment === METHOD.bni ? ImagePath.bankBni.alt : ImagePath.bankBsim.alt}
									onLoad={() => setLoading(false)}
								/>
								<p className="account-number">
									{coorporateProfile.dataAccountBalanceIM?.vaNumber}
								</p>
								<button
									className="content-copy-img"
									type="button"
									onClick={() => navigator.clipboard.writeText(`${coorporateProfile.dataAccountBalanceIM?.vaNumber}`)}
								>
									<img
										className="content-copy-img"
										src={ImagePath.contentCopy.src}
										alt={ImagePath.contentCopy.alt}
									/>
								</button>
							</div>
							<div className="warning-container">
								<p className="virtual-account-purpose">
									<div className="flex-wrap">
										<img
											className="warning-img"
											src={ImagePath.warningSign.src}
											alt={ImagePath.warningSign.alt}
										/>
										<p className="warning-text">
											Proses menambahkan saldo Dana Siaga membutuhkan
											waktu setidaknya 10 menit. Jika saldo tidak
											berubah setelah top-up, harap melakukan refresh
											di beranda.
										</p>
									</div>
								</p>
							</div>
						</div>
						<p className="deposit-text">Instruksi Transfer</p>
						<div className="accordion-layout">
							<div className="accordion">
								{accordionData(coorporateProfile.dataAccountBalanceIM?.methodPayment || 1)
								.map(({ title, type, imageSrc, imageAlt, content }) => (
									<Accordion key={title} title={title} stepper type={type} imageSrc={imageSrc} imageAlt={imageAlt} content={content} />
								))}
							</div>
						</div>
					</div>
				)}
			</div>
			<div className="deposit-layout">
				{isLoggedIn && coorporateProfile.dataAccountBalance?.vaNumber && (
					<div className="card information-card">
						<div className="card virtual-account-info">
							<p className="virtual-account-purpose">
								Tujuan Virtual Account
							</p>
							<p className="virtual-account-holder">{coorporateProfile.dataAccountBalance?.vaName}</p>
							<div className="flex-wrap">
								<img
									referrerPolicy="no-referrer"
									className={loading ? "loading-image" : "bank-logo"}
									src={coorporateProfile.dataAccountBalance?.methodPayment === METHOD.bni ? ImagePath.bankBni.src : ImagePath.bankBsim.src}
									alt={coorporateProfile.dataAccountBalance?.methodPayment === METHOD.bni ? ImagePath.bankBni.alt : ImagePath.bankBsim.alt}
									onLoad={() => setLoading(false)}
								/>
								<p className="account-number">
									{coorporateProfile.dataAccountBalance?.vaNumber}
								</p>
								<button
									className="content-copy-img"
									type="button"
									onClick={() => navigator.clipboard.writeText(`${coorporateProfile.dataAccountBalance?.vaNumber}`)}
								>
									<img
										className="content-copy-img"
										src={ImagePath.contentCopy.src}
										alt={ImagePath.contentCopy.alt}
									/>
								</button>
							</div>
							<div className="warning-container">
								<p className="virtual-account-purpose">
									<div className="flex-wrap">
										<img
											className="warning-img"
											src={ImagePath.warningSign.src}
											alt={ImagePath.warningSign.alt}
										/>
										<p className="warning-text">
											Proses menambahkan saldo Dana Siaga membutuhkan
											waktu setidaknya 10 menit. Jika saldo tidak
											berubah setelah top-up, harap melakukan refresh
											di beranda.
										</p>
									</div>
								</p>
							</div>
						</div>
						<p className="deposit-text">Instruksi Transfer</p>
						<div className="accordion-layout">
							<div className="accordion">
								{accordionData(coorporateProfile.dataAccountBalance?.methodPayment || 1).map(({ title, type, imageSrc, imageAlt, content }) => (
									<Accordion key={title} title={title} stepper type={type} imageSrc={imageSrc} imageAlt={imageAlt} content={content} />
								))}
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default Deposit;
